import { Component, OnInit } from '@angular/core';
import { PaymentTransactions } from './payment-transactions.model';
import { PaymentService } from '../../services/payment.service';
import { ConfirmationService, MessageService, MenuItem } from 'primeng/api';
import { SessionStorageService } from '../../services/session-storage.service';
import { PaymentTransactionsView } from "./payment-transactions-view.model";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from "primeng/toast";
import { ProgressBarModule } from "primeng/progressbar";
import { ChipModule } from "primeng/chip";
import { PermissionService } from '../../security/permission.service';
import { app_permissions } from '../../security/app-permissions';

@Component({
    selector: 'app-payment-transactions',
    templateUrl: './payment-transactions.component.html',
    styleUrls: ['./payment-transactions.component.css'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        BreadcrumbModule,
        TableModule,
        ButtonModule,
        TooltipModule,
        ToastModule,
        ProgressBarModule,
        ChipModule
    ]
})
export class PaymentTransactionsComponent implements OnInit {

    breadcrumbItems: MenuItem[] | undefined;
    homeBreadcrumb: MenuItem | undefined;

    paymentTransactions: PaymentTransactionsView[] = [];
    selectedPaymentTransactions: PaymentTransactionsView[] = [];
    isLoading: boolean = false;
    first = 0;
    rows = 20;
    totalRecords = 0;

    canViewTransactions = false;
    canCreateTransaction = false;
    canEditTransaction = false;
    canDeleteTransaction = false;

    constructor(
        private paymentService: PaymentService,
        private sessionStorageService: SessionStorageService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private permissionService: PermissionService
    ) { }

    ngOnInit(): void {
        this.canViewTransactions = this.permissionService.hasPermission(app_permissions.accounts.voucher.view);
        this.canCreateTransaction = this.permissionService.hasPermission(app_permissions.accounts.voucher.create);
        this.canEditTransaction = this.permissionService.hasPermission(app_permissions.accounts.voucher.edit);
        this.canDeleteTransaction = this.permissionService.hasPermission(app_permissions.accounts.voucher.delete);
        if (!this.canViewTransactions) {
            this.isLoading = false;
            return;
        }
        this.breadcrumbItems = [
            { label: 'Accounts', routerLink: '/accounts' },
            { label: 'Payment Transactions' }
        ];
        this.homeBreadcrumb = { icon: 'pi pi-home', routerLink: '/' };
        this.loadData();
    }

    loadData() {
        if (!this.canViewTransactions) {
            this.isLoading = false;
            return;
        }
        this.isLoading = true;
        this.paymentService.getPaymentTransactionsByCompany(this.sessionStorageService.getCompany()?.id ?? 0).subscribe({
            next: (data) => {
                this.paymentTransactions = data;
                this.totalRecords = data.length;
                this.isLoading = false;
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Error loading payment transactions'
                });
                this.isLoading = false;
            }
        });
    }

    addPaymentTransactions() {
        if (!this.canCreateTransaction) {
            return;
        }
        //add implementation
    }

    editPaymentTransactions(paymentTransaction: PaymentTransactions) {
        if (!this.canEditTransaction) {
            return;
        }
        //edit implementation
    }

    deletePaymentTransactions(paymentTransaction: PaymentTransactions) {
        if (!this.canDeleteTransaction) {
            return;
        }
        //delete implementation
    }

}
